<template>
  <div class="m-content">
    <HeaderBox/>
    <div class="report-content">
      <div class="report-area">
        <p class="report-title">你的大学生基础素质评分为</p>
        <p class="report-score" v-html="result.totalScore"></p>
      </div>
      <div class="report-area">
        <p class="report-title">各素质项得分为</p>
        <img class="report-img score-img":src=result.raidaImage />
      </div>
    </div>
    <FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'ExcellentReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      result:""
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-优秀大学生图鉴')
    this.getReport()
  },
  methods:{
    getReport(res){
      const options = {
        method: 'post',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({
          openId: this.shengyaUser.openid
        }),
        url:'/cob/cosExcellentReport.do'
      };
      axios(options)
      .then((response)=>{
        if(response.data.result.success){
          const data = response.data.data
          if(data){
            this.result = data.cosExcellent
            // 弹幕
            let text = ''
            if(this.result.totalScore<=60){
              text='的得分为'+this.result.totalScore+'，还要加油鸭！'
            }else{
              text='居然达到了'+this.result.totalScore+'，哇噻！'
            }
            store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
          }
        }
      })
      .catch((error)=>{
        console.warn(error);
      })
    },
  }
}
</script>
<style scoped>
</style>
